import { CheckZipErrorType } from "./CheckZipErrorType";

export class CheckZipResponse {
  country: string;
  city: string;
  postalCode: string;
  region: string;
  isSupported: boolean;
  errorType?: CheckZipErrorType;

  constructor(data: any) {
    for (var propName in data) {
      (this as any)[propName] = data[propName];
    }
  }

  userMessage = (): string => {
    if (
      !!this.errorType &&
      this.errorType === CheckZipErrorType.CannotResolve
    ) {
      return "Ungültige Postleitzahl";
    }
    if (
      !!this.errorType &&
      this.errorType === CheckZipErrorType.OutsideRegion
    ) {
      return `Buchungen für ${this.postalCode} nehmen wir unter 04087409121 gerne entgegen.`;
    }
    return `${this.postalCode}, ${this.city}`;
  };

  alertType = (): "success" | "warning" | "error" => {
    if (
      !!this.errorType &&
      this.errorType === CheckZipErrorType.CannotResolve
    ) {
      return "error";
    }
    if (
      !!this.errorType &&
      this.errorType === CheckZipErrorType.OutsideRegion
    ) {
      return "warning";
    }
    return "success";
  };
}
